import { useCallback } from 'react';
import { useRemoteConfig, createFlagsScheme, schema } from '@funtech-int/yango-shared';
import { useI18n } from '@funtech-int/rival-react';

import { clientConfig } from '@/config/client';

const { clientSupportLinks: defaultSupportLinks } = clientConfig;

const supportLinksScheme = createFlagsScheme({
    support_links: schema.mapOf(schema.string).optional(),
});

export const useClientSupport = () => {
    const remoteConfig = useRemoteConfig(supportLinksScheme);
    const supportLinks = remoteConfig.get('support_links');

    const language = useI18n().locale.get().lang;

    const clientSupportLink = supportLinks?.[language] ?? (defaultSupportLinks.en as string);

    const openClientSupport = useCallback(() => {
        window.open(clientSupportLink, '_blank');
    }, [clientSupportLink]);

    return { openClientSupport, clientSupportLink };
};
